export enum AppFeatures {
  ADVANCED_MASS_OPERATIONS_AI_AUTO_STORY = 200,
  ADVANCED_MASS_OPERATIONS_AI_SYNOPSIS = 203, // implemented
  ADVANCED_MASS_OPERATIONS_ALL_ITEMS_IN_CURRENT_FEED_TAB = 2, // implemented
  ADVANCED_MASS_OPERATIONS_DETECT_LANGUAGE = 164, // implemented
  ADVANCED_MASS_OPERATIONS_EDIT_SENTIMENT = 5, // implemented
  ADVANCED_MASS_OPERATIONS_EMAIL_SELECTED = 6, // implemented
  ADVANCED_MASS_OPERATIONS_ESTIMATE_SENTIMENT = 177, // implemented
  ADVANCED_MASS_OPERATIONS_EXECUTE_SPEECH_TO_TEXT = 184, // implemented
  ADVANCED_MASS_OPERATIONS_EXPORT_TO_EXCEL = 7,
  ADVANCED_MASS_OPERATIONS_EXPORT_TO_WORD = 8,
  ADVANCED_MASS_OPERATIONS_FACE_DETECTION = 202, // implemented
  ADVANCED_MASS_OPERATIONS_INSTAGRAM_SCRAPPER = 205, // implemented
  STORIES_ACCESS = 208, // implemented
  ADVANCED_MASS_OPERATIONS_RECALCULATE_POST_REACH = 181, // implemented
  ADVANCED_MASS_OPERATIONS_REMOVE_FROM_FEED = 9, // implemented
  ADVANCED_MASS_OPERATIONS_REMOVE_FROM_FEED_APPLY_TO_CHILD = 172, // implemented
  ADVANCED_MASS_OPERATIONS_RE_HARVEST = 162,
  ADVANCED_MASS_OPERATIONS_RE_INDEX = 163,
  ADVANCED_MASS_OPERATIONS_ROOT = 1,
  ADVANCED_MASS_OPERATIONS_SCREEN_CAPTURE = 201,
  ADVANCED_MASS_OPERATIONS_SELECTED_ITEMS_IN_ALL_FEEDS_TAB = 3,
  ADVANCED_MASS_OPERATIONS_SELECTED_ITEMS_IN_CURRENT_FEED_TAB = 4,
  ADVANCED_MASS_OPERATIONS_SET_CATEGORIES = 10,
  ADVANCED_MASS_OPERATIONS_SHARE_TO_FEED = 11,
  ADVANCED_MASS_OPERATIONS_TRANSLATION = 204,
  ADVANCED_MASS_OPERATIONS_VIEW_ARCHIVED_OBJECTS = 155,
  ADVANCED_MASS_OPERATIONS_VIEW_DELETED_OBJECTS = 156,
  ALERTS_MANAGER_COMPANY_ALERTS = 13,
  ALERTS_MANAGER_MY_ALERTS = 14,
  ALERTS_MANAGER_ROOT = 12,
  ALERT_EMAIL_ADD_TO_FEED_BTN = 154,
  ALERT_ROOT = 119,
  BREADCRUMB_CONTEXT_MENU_CREATE_NEW_AND_ADD_TO_FAVORITES = 44, // implemented
  BREADCRUMB_CONTEXT_MENU_CREATE_NEW_AND_LINK = 42, // implemented
  BREADCRUMB_CONTEXT_MENU_EDIT_FAVORITES = 45, // implemented
  BREADCRUMB_CONTEXT_MENU_EDIT_LINKED_DIMENSIONS = 43, // implemented
  BREADCRUMB_CONTEXT_MENU_ROOT = 41,
  BREADCRUMB_DIMENSION_MENU_EDIT_DIMENSION = 47, // implemented
  BREADCRUMB_DIMENSION_MENU_REMOVE_DIMENSIONS = 49, // implemented
  BREADCRUMB_DIMENSION_MENU_ROOT = 46, // implemented
  BREADCRUMB_DIMENSION_MENU_TOGGLE_NOT_DIMENSION = 48, // implemented
  CHROME_USER_EXTENSION_EXTENSION_MANAGER = 167,
  CHROME_USER_EXTENSION_POST_MANAGER = 168,
  CHROME_USER_EXTENSION_ROOT = 166,
  CHROME_USER_EXTENSION_SOURCE_CATALOG_MANAGER = 169,
  COMPANY_MANAGER_COMPANY_ACTIVITY_LOG = 16,
  COMPANY_MANAGER_COMPANY_CATEGORY_MANAGER = 159,
  COMPANY_MANAGER_COMPANY_GROUP_MANAGEMENT = 110,
  COMPANY_MANAGER_COMPANY_OBJECTS_TREE = 17,
  COMPANY_MANAGER_COMPANY_OUTPUT_LOG = 18,
  COMPANY_MANAGER_COMPANY_SEARCH_LOG = 19,
  COMPANY_MANAGER_COMPANY_SEARCH_STATS = 20,
  COMPANY_MANAGER_COMPANY_SYNOPSIS_LOG = 149,
  COMPANY_MANAGER_COMPANY_USER_MANAGEMENT = 21,
  COMPANY_MANAGER_ROOT = 15,
  CONNECTOR_MANAGER_APPROVE_RULE = 148,
  CONNECTOR_MANAGER_CREATE_POST_FROM_ATTACHMENT = 182,
  CONNECTOR_MANAGER_CREATE_RULE = 147,
  CONNECTOR_MANAGER_ROOT = 22,
  CREATE_MENU_ROOT = 113,
  CREATE_MISSION = 152,
  DASHBOARD_REORDER_WIDGETS = 23,
  DASHBOARD_RESIZE_WIDGETS = 24,
  DASHBOARD_ROOT = 102,
  DASHBOARD_SETTINGS_CONTENT_AND_WIDGETS_CACHING = 25,
  DASHBOARD_SETTINGS_ROOT = 103,
  DATA_SOURCES_INSTAGRAM_ACCESS = 179,
  DATA_SOURCES_TELEGRAM_ACCESS = 158,
  DATA_SOURCES_TIKTOK_ACCESS = 178,
  DIMENSION_ROOT = 108,
  EXPORT_AND_SHARE_EXPORT_TO_EXCEL = 33,
  EXPORT_AND_SHARE_EXPORT_TO_WORD = 34,
  EXPORT_AND_SHARE_OBJECT_OUTPUT_LOG = 35,
  EXPORT_AND_SHARE_SCHEDULES = 36,
  EXPORT_AND_SHARE_ROOT = 32,
  EXPORT_AND_SHARE_SHARE_BY_EMAIL = 37,
  FACEBOOK_PAGES_ROOT = 106,
  FACEBOOK_PUBLISHER_ROOT = 26,
  FACET_FILTERS_ACTIVATE_FILTERS = 30,
  FACET_FILTERS_PROPERTIES_CONTENT_STATS = 165,
  FACET_FILTERS_PROPERTIES_NAMED_ENTITIES = 125,
  FACET_FILTERS_PROPERTIES_ROOT = 120,
  FACET_FILTERS_PROPERTIES_SENTIMENT_EDITING = 121,
  FACET_FILTERS_PROPERTIES_SOURCE_CATEGORIZATION = 123,
  FACET_FILTERS_PROPERTIES_SOURCE_RANKING = 124,
  FACET_FILTERS_PROPERTIES_SYNOPSIS_EDITING = 122,
  FACET_FILTERS_ROOT = 29,
  FACET_FILTERS_SAVE_ACTIVE_FILTERS_AS_DIMENSION = 31,
  FEED_QUERY_EDITOR_ADVANCED_QUERY_EDITOR = 39,
  FEED_QUERY_EDITOR_FILTER_QUERY = 140,
  FEED_QUERY_EDITOR_HINTS = 145,
  FEED_QUERY_EDITOR_HISTORY = 146,
  FEED_QUERY_EDITOR_QUERY_EXPANDER = 185,
  FEED_QUERY_EDITOR_ROOT = 38,
  FEED_QUERY_EDITOR_SEARCH_BUILDER = 40,
  FEED_ROOT = 107,
  FEED_SEARCH_RESULTS_ARTICLE_IMAGE_FACE_DETECTION = 139,
  FEED_SEARCH_RESULTS_DEBUG_POST = 57, // implemented
  FEED_SEARCH_RESULTS_DEBUG_SOURCE = 58, // implemented
  FEED_SEARCH_RESULTS_DISPLAY_SENTIMENT_IS_MODIFIED = 170, // implemented
  FEED_SEARCH_RESULTS_DISPLAY_SENTIMENT_IS_MODIFIED_BY_USER = 171,
  FEED_SEARCH_RESULTS_EDIT_SENTIMENT = 52, // implemented
  FEED_SEARCH_RESULTS_EDIT_WORKFLOW = 129, // implemented
  FEED_SEARCH_RESULTS_ITEMS_PER_PAGE = 51, // implemented
  FEED_SEARCH_RESULTS_QUICK_FILTER_QUERY = 141, //implemented
  FEED_SEARCH_RESULTS_QUICK_GOOGLE_TRANSLATE = 132, // implemented
  FEED_SEARCH_RESULTS_REMOVE_CONTENT_FROM_FEED = 53, // implemented
  FEED_SEARCH_RESULTS_REMOVE_SOURCE_FROM_FEED = 54, // implemented
  FEED_SEARCH_RESULTS_ROOT = 50,
  FEED_SEARCH_RESULTS_SELECT_CONTENT = 55, // implemented
  FEED_SEARCH_RESULTS_SETTINGS_DISPLAY_SETTINGS = 61, // view options
  FEED_SEARCH_RESULTS_SETTINGS_EXPORT_TO_RSS = 62,
  FEED_SEARCH_RESULTS_SETTINGS_ROOT = 60,
  FEED_SEARCH_RESULTS_SETTINGS_SORT_SETTINGS = 63, // view options
  FEED_SEARCH_RESULTS_SET_CATEGORIES = 56, // implemented
  FEED_SEARCH_RESULTS_VIEW_DETAILS = 59, // implemented
  FEED_SEARCH_RESULTS_LINK_RELATED_CONTENT_MANUALLY = 198, // implemented
  FEED_SEARCH_RESULTS_VIEW_CATEGORIES = 196, // implemented
  FEED_SETTINGS_CONTENT_AND_WIDGETS_CACHING = 65,
  FEED_SETTINGS_CONTENT_SCREEN_CAPTURE = 116,
  FEED_SETTINGS_FORCE_SCREEN_CAPTURING = 66,
  FEED_SETTINGS_GROUP_SIMILAR_CONENT = 67,
  FEED_SETTINGS_LOCK_FEED_TIME_PERIOD = 68,
  FEED_SETTINGS_PAUSE_FREEZE_FEED = 69,
  FEED_SETTINGS_REPORT_GENERATOR = 117,
  FEED_SETTINGS_ROOT = 64,
  FEED_SETTINGS_TRIGGER_SCREEN_CAPTURING = 70,
  FEED_WIDGETS_PANE_REORDER_WIDGETS = 80,
  FEED_WIDGETS_PANE_RESIZE_WIDGETS = 81,
  FEED_WIDGETS_PANE_ROOT = 79,
  FEED_WIDGETS_PANE_WIDGETS_MANAGER = 82,
  GLOBAL_COMPANY_MANAGER_ROOT = 126,
  HAS_ACCESS_TO_EXPERIMENTAL_FEATURES = 180,
  IMPORT_CATEGORIES = 153,
  JUMP_TO_ROOT = 100,
  NOTIFICATIONS_ROOT = 105,
  OBJECT_APPLICABLE_ACTIONS_COPY_OBJECT = 173,
  OBJECT_APPLICABLE_ACTIONS_GRANT_PERMISSIONS = 175,
  OBJECT_APPLICABLE_ACTIONS_MOVE_OBJECT = 174,
  POST_DETAILS_AUTO_MASS_RELATED_POSTS = 187,
  POST_DETAILS_AUTO_RELATED_POSTS = 186,
  POST_DETAILS_PANE_AI_SYNOPSIS = 188,
  POST_DETAILS_PANE_CATEGORIES = 75,
  POST_DETAILS_PANE_ENTITIES = 76,
  POST_DETAILS_PANE_FULL_CONTENT = 72, //implemented
  POST_DETAILS_PANE_KEYPHRASES = 77,
  POST_DETAILS_PANE_PHRASES_AND_CONCEPTS = 74,
  POST_DETAILS_PANE_QUICK_STORY_REPORT = 130, //implemented
  POST_DETAILS_PANE_QUICK_STORY_REPORT_EDITOR = 131,
  POST_DETAILS_PANE_ROOT = 71,
  POST_DETAILS_PANE_SENTIMENT = 73,
  POST_DETAILS_PANE_SYNOPSIS = 114, //implemented
  POST_DETAILS_PANE_SYNOPSIS_COUNTER = 176,
  POST_DETAILS_PANE_SYNOPSIS_EDITOR = 78,
  POST_DETAILS_PANE_TRANSLATION = 133, //implemented
  POST_DETAILS_PANE_TRANSLATION_EDITOR = 134,
  SENSIKA_PRIVATE_API_LIVE_FEED_ACCESS = 189,
  SENSIKA_PUBLIC_API_ACCESS_FEED_POSTS = 183,
  SYSTEM_ALERTS = 150,
  SYSTEM_API_ROUTE_MANAGER = 118,
  SYSTEM_EXPORT_SCHEDULES = 151,
  SYSTEM_ROLE_MANAGEMENT = 109,
  SYSTEM_ROOT = 111,
  SYSTEM_SOURCE_CATALOG = 160,
  SYSTEM_SOURCE_CATALOG_IMPORT = 161,
  TEST_DEBUG_ROOT = 101,
  USER_ACTIVITY_LOG_COMPANY_HOME_LOG_PANE = 95,
  USER_ACTIVITY_LOG_ROOT = 94,
  USER_ACTIVITY_LOG_USER_HOME_LOG_PANE = 96,
  USER_PROFILE_ROOT = 97,
  USER_PROFILE_USER_PROFILE_EDITOR = 99,
  USER_PROFILE_USER_SETTINGS_EDITOR = 98,
  WIDGETS_LIBRARY_COMPARATIVE_WIDGETS = 85,
  WIDGETS_LIBRARY_DATA_TABLES = 86,
  WIDGETS_LIBRARY_ROOT = 83, // implemented
  WIDGETS_LIBRARY_SIMPLE_WIDGETS = 84,
  WIDGET_DRILL_DOWN = 90,
  WIDGET_DUPLICATE = 87, // implemented
  WIDGET_EXPORT = 88, // implemented
  WIDGET_FILTER_DIMENSIONS = 91, // implemented
  WIDGET_OFFLINE_REPORTS_GENERATOR = 89,
  WIDGET_PIVOT_DIMENSIONS = 92,
  WIDGET_QUICK_DIMENSION = 93,
  WIDGET_ROOT = 104,
  WORKSPACE_ROOT = 112,
  WORKSPACE_SETTINGS_ROOT = 115,
}
